import { PerfilSimple, User } from '../../types/User';

const deduplicateProfilesById = (profiles: PerfilSimple[]): PerfilSimple[] => {
  const seenIds = new Set<number>();

  return profiles.filter(profile => {
    if (seenIds.has(profile.id)) return false;
    seenIds.add(profile.id);
    return true;
  });
};

export const sanitizeUserSchools = (user: User): User => ({
  ...user,
  schools: user.schools.map(school => ({
    ...school,
    profile: deduplicateProfilesById(school.profile ?? []),
  })),
});
